import { render, staticRenderFns } from "./RequestPhraseDialog.vue?vue&type=template&id=020db7c1&scoped=true"
import script from "./RequestPhraseDialog.vue?vue&type=script&lang=js"
export * from "./RequestPhraseDialog.vue?vue&type=script&lang=js"
import style0 from "./RequestPhraseDialog.vue?vue&type=style&index=0&id=020db7c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020db7c1",
  null
  
)

export default component.exports